var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOne(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#0CA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.991 10.537h-2.496l-2.688 1.888-.56 2.832 2.688-1.888-1.712 8.56h2.496l2.272-11.392zM24.116 15.593c0-1.792-1.264-2.368-2.16-2.368a3.13 3.13 0 00-1.92.656l.672-3.344h-2.496L15.94 21.929h2.496l1.04-5.2c.192-.96.752-1.248 1.328-1.248.32 0 .72.24.72.816a2.1 2.1 0 01-.048.432l-1.04 5.2h2.496l1.072-5.344c.064-.288.112-.64.112-.992z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/one.dfda41bb.svg";
export { SvgOne as ReactComponent };